// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../primitives/I18n.res.js";
import * as BigJs from "big.js";

function fromRawValue(capacityPrecision, value) {
  if (capacityPrecision !== undefined) {
    return BigJs.Big(value).div(BigJs.Big(Math.pow(10, capacityPrecision))).toNumber();
  } else {
    return value;
  }
}

function toRawValue(capacityPrecision, value) {
  if (capacityPrecision !== undefined) {
    return BigJs.Big(value).times(BigJs.Big(Math.pow(10, capacityPrecision))).toNumber() | 0;
  } else {
    return value | 0;
  }
}

function make(capacityUnit, capacityPrecision) {
  if (capacityUnit !== undefined && capacityPrecision !== undefined) {
    return {
      unit: capacityUnit,
      precision: capacityPrecision
    };
  }
}

let BulkUnit = {
  make: make
};

function formatStock(bulkUnit, quantity) {
  if (bulkUnit === undefined) {
    return quantity.toString();
  }
  let qty = fromRawValue(bulkUnit.precision, quantity);
  let formatted = I18n.decimalFormat(undefined, 0, 3, undefined, qty);
  return formatted + ` ` + bulkUnit.unit;
}

function formatUnitPrice(bulkUnit, currencyOpt, isSalePrice, value) {
  let currency = currencyOpt !== undefined ? currencyOpt : "EUR";
  let fractionDigits = isSalePrice ? 2 : 3;
  let formattedUnitPrice = I18n.currencyFormat(undefined, currency, fractionDigits, fractionDigits, value);
  if (bulkUnit !== undefined) {
    return formattedUnitPrice + ` / ` + bulkUnit.unit;
  } else {
    return formattedUnitPrice;
  }
}

export {
  fromRawValue,
  toRawValue,
  BulkUnit,
  formatStock,
  formatUnitPrice,
}
/* I18n Not a pure module */
